/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import {
  DXP_TENANT_STATUS_CODE_DEPLOYING,
  DXP_TENANT_STATUS_CODE_ERROR,
  DXP_TENANT_STATUS_CODE_LIVE,
} from './DxpTenantStatus.entity.constant';

/**
 * The dxp tenant status type.
 * @export
 */
export type EntityDxpTenantStatus = io.TypeOf<typeof DxpTenantStatus>;

/**
 * The dxp tenant status definition.
 * @export
 */
export const DxpTenantStatus = io.type(
  {
    code: io.union([
      io.literal(DXP_TENANT_STATUS_CODE_DEPLOYING),
      io.literal(DXP_TENANT_STATUS_CODE_LIVE),
      io.literal(DXP_TENANT_STATUS_CODE_ERROR),
    ]),
    message: io.string,
  },
  `DxpTenantStatus`,
);
